import { DownOutlined } from '@ant-design/icons'
import { Dropdown, Menu, PageHeader } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import routes from '@/constants/routes'

const IdCardsPageHeader = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const menu = (
    <Menu>
      <Menu.Item key="1" onClick={() => navigate(routes.idCardsImport.path)}>
        {t('components.pages.idCards.list.pageHeader.csvImport')}
      </Menu.Item>
    </Menu>
  )

  return (
    <PageHeader
      ghost={false}
      title={t('components.pages.idCards.list.pageHeader.title')}
      extra={[
        <Dropdown.Button
          icon={<DownOutlined />}
          key="action"
          type="primary"
          overlay={menu}
          onClick={() => navigate(routes.createIdCard.path)}
        >
          {t('components.pages.idCards.list.pageHeader.new')}
        </Dropdown.Button>,
      ]}
    />
  )
}

IdCardsPageHeader.displayName = 'IdCardsPageHeader'
export default IdCardsPageHeader
